import { GameListRep } from "@/api/home";
import { create } from "zustand";

interface State {
    providers: GameListRep[];
}

interface Action {
    setProviders: (value: GameListRep[]) => void;
}

const initialState: State = {
    providers: [],
};

export const useProviderStore = create<State & Action>()((set) => {
    return {
        ...initialState,
        setProviders: (value: GameListRep[]) => {
            return set({ providers: value });
        },
    };
});
